import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 border rounded-md p-1" data-testid="language-switcher">
      <Button
        variant={language === 'fr' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => setLanguage('fr')}
        data-testid="lang-fr-button"
        className="h-7 px-3 text-xs font-semibold uppercase"
      >
        FR
      </Button>
      <Button
        variant={language === 'en' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => setLanguage('en')}
        data-testid="lang-en-button"
        className="h-7 px-3 text-xs font-semibold uppercase"
      >
        EN
      </Button>
    </div>
  );
};